export var promoteMobileLevels;
(function (promoteMobileLevels) {
    promoteMobileLevels[promoteMobileLevels["lowLevel"] = 6] = "lowLevel";
    promoteMobileLevels[promoteMobileLevels["highLevel"] = 15] = "highLevel";
})(promoteMobileLevels || (promoteMobileLevels = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/PromoteMobileLevels.ts
// module id = 2287
// module chunks = 3